/**
 * API de Informes
 * Todas las llamadas relacionadas con informes centralizadas
 */
import apiClient from './axios.config';

const ENDPOINT = 'api/informes';

/**
 * Obtiene el último número de informe
 * @returns {Promise<{siguiente: number}>}
 */
export const getUltimoNumeroInforme = async () => {
  const { data } = await apiClient.get(`${ENDPOINT}/ultimo-numero`);
  return data;
};

/**
 * Obtiene lista de informes
 * @returns {Promise<Array>}
 */
export const getInformes = async () => {
  const { data } = await apiClient.get(ENDPOINT);
  return data;
};

/**
 * Obtiene un informe por ID
 * @param {number|string} id 
 * @returns {Promise<Object>}
 */
export const getInformeById = async (id) => {
  const { data } = await apiClient.get(`${ENDPOINT}/${id}`);
  return data;
};

/**
 * Crea un nuevo informe
 * @param {Object} informeData 
 * @returns {Promise<Object>}
 */
export const createInforme = async (informeData) => {
  const { data } = await apiClient.post(ENDPOINT, informeData);
  return data;
};

/**
 * Guarda archivos del informe (firma, imagen)
 * @param {Object} archivosData - { NroInforme, FirmaInspector, ImagenAdjunta }
 * @returns {Promise<{success: boolean, rutas: Object}>}
 */
export const guardarArchivosInforme = async (archivosData) => {
  const { data } = await apiClient.post(`${ENDPOINT}/guardar-archivos`, archivosData);
  return data;
};

/**
 * Confirma un informe
 * @param {number|string} id 
 * @param {Object} confirmData - { Estado, Observacion }
 * @returns {Promise<Object>}
 */
export const confirmarInforme = async (id, confirmData) => {
  const { data } = await apiClient.put(`${ENDPOINT}/${id}/confirmar`, confirmData);
  return data;
};

/**
 * Devuelve un informe para edición
 * @param {number|string} id 
 * @param {string} observacion 
 * @returns {Promise<Object>}
 */
export const devolverInforme = async (id, observacion) => {
  const { data } = await apiClient.put(`${ENDPOINT}/${id}/devolver`, { 
    Observacion: observacion 
  });
  return data;
};

/**
 * Guarda descargo de un informe
 * @param {number|string} id 
 * @param {Object} descargoData - { texto, firmaBase64 }
 * @returns {Promise<Object>}
 */
export const guardarDescargo = async (id, descargoData) => {
  const { data } = await apiClient.put(`${ENDPOINT}/descargo/${id}`, descargoData);
  return data;
};

/**
 * Actualiza el estado de un informe
 * @param {number|string} id 
 * @param {string} nuevoEstado 
 * @param {string} usuarioId 
 * @returns {Promise<Object>}
 */
export const actualizarEstadoInforme = async (id, nuevoEstado, usuarioId) => {
  const { data } = await apiClient.put(`${ENDPOINT}/estado/${id}`, {
    nuevoEstado,
    usuarioId,
  });
  return data;
};

/**
 * Reenvía un informe devuelto con datos actualizados
 * @param {number|string} id - ID del informe
 * @param {Object} informeData - Datos actualizados del informe
 * @returns {Promise<Object>}
 */
export const reenviarInforme = async (id, informeData) => {
  const { data } = await apiClient.put(`${ENDPOINT}/${id}/reenviar`, informeData);
  return data;
};

const informesApi = {
  getUltimoNumeroInforme,
  getInformes,
  getInformeById,
  createInforme,
  guardarArchivosInforme,
  confirmarInforme,
  devolverInforme,
  guardarDescargo,
  actualizarEstadoInforme,
  reenviarInforme,
};

export default informesApi;
